
export default {
  props: {
    blogs: { type: Array, required: true },
    closeSearch: { type: Function, required: true },
    withCenterSearch: { type: Boolean, default: false },
  },

  computed: {
    imgProps() {
      return {
        width: 73,
        height: 73,
        fit: "cover",
        modifiers: { crop: "entropy" },
      };
    },
    swiperClass() {
      return `center-search-blogs-swiper`;
    },
    getBlogProps() {
      return (this.blogs || []).map(({ title, image, url }) => {
        return {
          title,
          image,
          url,
        };
      });
    },
  },
};
